
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface ProfileNavProps {
  isPublic?: boolean;
}

export const ProfileNav = ({ isPublic }: ProfileNavProps) => {
  const navigate = useNavigate();

  return (
    <nav className="bg-white/80 backdrop-blur-md border-b sticky top-0 z-50 animate-fade-in">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-baseline gap-2">
            <span className="text-xl font-bold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
              GetListSpace
            </span>
            <span className="text-xs text-gray-400/60">
              Made with ♥
            </span>
          </div>
          {!isPublic && (
            <Button
              variant="ghost"
              onClick={() => navigate("/dashboard")}
              className="hover:bg-blue-50"
            >
              Back to Dashboard
            </Button>
          )}
        </div>
      </div>
    </nav>
  );
};
